import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log("Something is Unexpected?? Report at https://www.linkedin.com/in/0xsahil/")
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);